import React, { useEffect, useState } from "react";
import {
  Box,
  ButtonStyled,
  FormButtonStyled,
  HeadingStyled,
  LabelStyled,
  LazyImage,
  TextStyled,
} from "../../styled/Elements";
import { ForgetPassImg } from "../../styled/AllImages";
import { Form, Modal } from "react-bootstrap";
import ValidatedInput from "../../common/inputFields/ValidatedInput";
import { useTranslation } from "react-i18next";
import { SelectionDropdown } from "../../styled/FormElements";
import {
  AdPlatform,
  cityList,
  NeighbourHood,
} from "../../../helpers/dummyConstants";
import MultipleImageUpload from "../../../pages/web/profile/components/MultipleImagesUpload";
import MultipleImageUploadDrag from "../../../pages/web/profile/components/MultipleImagesUploadDrag";
import PropertiesApi from "../../../services/api/propertiesApi";
import ValidationController from "../../common/inputFields/ValidationController";
import { Controller, useForm } from "react-hook-form";
import { toast } from "react-toastify";
import CustomRadioButton from "../../common/radioButtons/CustomRadio";
import { MultiSelectionDropdown } from "../../common/dropdowns/MultiSelectDropdown";
import { formatAmountForDisplay } from "../../../utils";
import VisitorApi from "../../../services/api/visitorApi";
import {
  buildAdvertiserRoleOptions,
  normalizeAdvertiserRoleValue,
} from "../../../utils/advertiserRoles";

const AddLookingForModal = (props) => {
  const citiesJson = localStorage.getItem("citiesList");
  const cities = citiesJson ? JSON.parse(citiesJson) : [];
  const platformJson = localStorage.getItem("platforms");
  const [propertyTypes, setPropertyTypes] = useState(null);
  const [advertiserTypes, setAdvertiserTypes] = useState([]);
  const platforms = citiesJson ? JSON.parse(platformJson) : [];
  const [loading, setLoading] = useState(false);
  const [districts, setDistricts] = useState([]);

  const {
    t,
    i18n: { language },
  } = useTranslation();
  const categoryOptions = [
    { id: "1", label: t("Residential") },
    { id: "2", label: t("Commercial") },
  ];
  const radioOptions = [
    { id: "1", label: t("Buy") },
    { id: "2", label: t("Rent") },
  ];
  const excludedIds = [1, 2, 3, 5, 6, 8, 9, 10];
  const bedroomState = [
    { label: "1", value: 1 },
    { label: "2", value: 2 },
    { label: "3", value: 3 },
    { label: "4", value: 4 },
    { label: "5", value: 5 },
    { label: "6", value: 6 },
    { label: "7", value: 7 },
    { label: "8", value: 8 },
    { label: "9", value: 9 },
    { label: "9+", value: 10 },
    { label: t("Studio"), value: 11 },
  ];
  const {
    register,
    control,
    handleSubmit,
    reset,
    watch,
    resetField,
    setValue,
    formState: { errors },
  } = useForm();

  const type_id = watch("property_type_id");
  const purpose_id = watch("type");
  const type = watch("property_category");

  const handleClose = () => {
    reset(); // Reset form fields
    props.onHide(); // Close modal
  };

  const getPropertyTypes = async (type) => {
    try {
      const body = await VisitorApi.getPropertyTypes(type);
      if (body?.data) {
        setPropertyTypes(
          body?.data &&
            body?.data
              ?.filter((item) => item?.id != 15)
              ?.map((item) => {
                return {
                  ...item,
                  label: language === "en" ? item?.en_name : item?.ar_name,
                  value: item?.id,
                };
              })
        );
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  const getAdvertiserTypes = async () => {
    try {
      const response = await PropertiesApi.getListingStatuses();
      setAdvertiserTypes(
        buildAdvertiserRoleOptions(response?.data?.advertiser_types)
      );
    } catch (error) {
      setAdvertiserTypes(buildAdvertiserRoleOptions());
    }
  };

  useEffect(() => {
    if (type) {
      getPropertyTypes(type);
    }
  }, [type, language]);

  useEffect(() => {
    getAdvertiserTypes();
  }, [language]);

  const handleAddProperty = async (dataObj) => {
    try {
      setLoading(true);
      const formData = {
        ...dataObj,
        // ...(!dataObj?.inside_mall_only_bit && { inside_mall_only_bit: 0 }),
        ...(!dataObj?.bedrooms && { bedrooms: "" }),
        action: "create",
      };
      const { code, message } = await PropertiesApi.addLookingForProp(formData);
      if (code === 200) {
        toast.success(t("looking_for_listing_added_success"));
        props?.getLookingForList();
        handleClose();
      }
      if (code === 100 || code === 204) {
        toast.error(message);
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      show={props?.show}
      onHide={handleClose}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Form onSubmit={handleSubmit(handleAddProperty)}>
        <Modal.Header className="">
          <Modal.Title>
            <HeadingStyled size="24px" className="">
              {t("AddListing")}
            </HeadingStyled>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* <Box className="d-flex flex-column align-items-center py-3 px-2"> */}
          <Box className="formEleContainer w-100">
            <LabelStyled className="labelForm">{t("service_type")}</LabelStyled>
            <ValidationController
              name={"type"}
              control={control}
              errors={errors}
              validationConfig={{
                required: `fieldRequired`,
              }}
              renderer={({ field }) => (
                <Box className="active-radio-container d-flex gap-2 flex-wrap">
                  {radioOptions.map((option) => (
                    <Box key={option.id}>
                      <CustomRadioButton
                        name="type"
                        label={t(option.label)}
                        value={option.id}
                        checked={option.id == purpose_id}
                        onChange={(e) => field.onChange(e.target.value)}
                      />
                    </Box>
                  ))}
                </Box>
              )}
            />
          </Box>
          <Box className="formEleContainer w-100">
            <LabelStyled className="labelForm">
              {t("Property_category")}
            </LabelStyled>
            <ValidationController
              name={"property_category"}
              control={control}
              errors={errors}
              validationConfig={{
                required: `fieldRequired`,
              }}
              renderer={({ field }) => (
                <Box className="active-radio-container d-flex gap-2 flex-wrap">
                  {categoryOptions.map((option) => (
                    <Box key={option.id}>
                      <CustomRadioButton
                        name="property_category"
                        label={t(option.label)}
                        value={option.id}
                        checked={option.id == type}
                        onChange={(e) => {
                          resetField("property_type_id", { defaultValue: "" });
                          resetField("bedrooms", { defaultValue: "" });
                          field.onChange(e.target.value);
                        }}
                      />
                    </Box>
                  ))}
                </Box>
              )}
            />
          </Box>
          {(type == 1 || type == 2) && (
            <>
              <Box className="formEleContainer w-100">
                <LabelStyled className="labelForm">
                  {t("Property_Type")}
                </LabelStyled>
                <ValidationController
                  name={"property_type_id"}
                  control={control}
                  errors={errors}
                  validationConfig={{
                    required: `fieldRequired`,
                  }}
                  renderer={({ field }) => (
                    <Box className="mt-2">
                      <SelectionDropdown
                        name={"property_type_id"}
                        placeholder={t("choose_type")}
                        value={field.value}
                        options={propertyTypes || []}
                        onChange={(e) => {
                          field.onChange(e.target.value);
                          setValue("inside_mall_only_bit", 0);
                        }}
                      />
                    </Box>
                  )}
                />
              </Box>
              <Box className="formEleContainer w-100">
                <LabelStyled className="labelForm">
                  {t("AdvertiserRoles")}
                </LabelStyled>
                <ValidationController
                  name={"customer_type"}
                  control={control}
                  errors={errors}
                  validationConfig={{}}
                  renderer={({ field }) => (
                    <Box className="mt-2">
                      <SelectionDropdown
                        name={"customer_type"}
                        placeholder={t("SelectAdvertiserRole")}
                        value={field.value}
                        options={advertiserTypes || []}
                        onChange={(e) =>
                          field.onChange(
                            normalizeAdvertiserRoleValue(
                              e.target.value,
                              advertiserTypes
                            )
                          )
                        }
                      />
                    </Box>
                  )}
                />
              </Box>
            </>
          )}
          {type == 2 && type_id && type_id == 13 && (
            <ValidationController
              name={"inside_mall_only_bit"}
              control={control}
              errors={errors}
              validationConfig={{
                required: false,
              }}
              renderer={({ field }) => (
                <Box className="check-box d-flex align-items-center gap-2 my-2">
                  <input
                    type="checkbox"
                    name={field.name}
                    checked={!!field.value}
                    id="terms-conditions"
                    onChange={(e) => field.onChange(e.target.checked ? 1 : 0)}
                  />
                  <LabelStyled
                    className="LabelStyled"
                    size="14px"
                    htmlFor="terms-conditions"
                  >
                    {t("Inside_Mall_Only")}
                  </LabelStyled>
                </Box>
              )}
            />
          )}
          {!!type && !!type_id && excludedIds.includes(type_id) && (
            <Box className="formEleContainer w-100">
              <LabelStyled className="labelForm">{t("Bedrooms")}</LabelStyled>
              <ValidationController
                name={"bedrooms"}
                control={control}
                errors={errors}
                validationConfig={{
                  required: false,
                }}
                renderer={({ field }) => (
                  // <SelectionDropdown
                  //   name={field.name}
                  //   placeholder={t("Neighbourhood")}
                  //   options={districts}
                  //   value={field.value}
                  //   onChange={(e) => field.onChange(e.target.value)}
                  // />
                  <SelectionDropdown
                    name={"bedrooms"}
                    placeholder={t("Bedrooms")}
                    value={field.value}
                    options={bedroomState}
                    onChange={(e) => field.onChange(e.target.value)}
                  />
                )}
              />
            </Box>
          )}
          <Box className="formEleContainer w-100">
            <LabelStyled className="labelForm">{t("City")}</LabelStyled>
            <ValidationController
              name={"cities"}
              control={control}
              errors={errors}
              validationConfig={{
                required: `fieldRequired`,
              }}
              renderer={({ field }) => (
                <MultiSelectionDropdown
                  name={field.name}
                  placeholder={t("City")}
                  options={cities}
                  value={field.value || []}
                  onChange={(selected) => field.onChange(selected)}
                />
              )}
            />
          </Box>
          {/* <ValidatedInput
            name="price"
            label={"Price_Range"}
            type="input"
            fieldType="number"
            placeholder={"Price_Range"}
            className={"w-100 mb-0 combined flex-wrap p-0"}
            register={register}
            errors={errors}
            validationRules={{
              required: false,
            }}
          /> */}
          <Controller
            name="price"
            control={control}
            rules={{ required: false }}
            render={({
              field: { onChange, value, ref },
              fieldState: { error },
            }) => (
              <ValidatedInput
                name="price"
                label={"Price_Range"}
                type="input"
                fieldType="text" // must be text to allow formatting
                placeholder={"Price_Range"}
                className={"w-100 mb-0 combined flex-wrap p-0"}
                value={value ? formatAmountForDisplay(value) : ""}
                onChange={(e) => {
                  const inputValue = e.target.value;
                  const raw = inputValue.replace(/,/g, "");

                  // Allow empty, decimal point only, or valid decimal numbers with up to 2 decimal places
                  if (
                    raw === "" ||
                    raw === "." ||
                    /^\d*\.?\d{0,2}$/.test(raw)
                  ) {
                    onChange(raw);
                  }
                }}
                errors={{ price: error }}
              />
            )}
          />

          {/* </Box> */}
        </Modal.Body>
        <Modal.Footer className="">
          <FormButtonStyled
            label={t("Cancel")}
            type="button"
            className=""
            clName=""
            bg="transparent"
            shadow="false"
            color="var(--lightGrey)"
            onClick={props.onHide}
            border="var(--border)"
          />
          <FormButtonStyled
            label={t("Publish")}
            className=""
            clName="mb-2"
            type="submit"
            bg="var(--themeColorSecondary)"
            disabled={loading}
            isLoading={loading}
          />
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default AddLookingForModal;
